import { laborRemotePersistenceDisabled } from "@/lib/labor/laborEnv";

/**
 * Matches Clamp QC: when true, Pre-Pack skips Supabase labor calls in local development unless the operator opts in with
 * `VITE_PREPACK_USE_SUPABASE_LABOR=true` in `ui/.env` or enables labor writes from the development account menu.
 */
export function prePackLaborRemotePersistenceDisabled(): boolean {
  return laborRemotePersistenceDisabled("prepack");
}
